import { Box, Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import SkillsCard from './SkillsCard'


const skillsArray = [
    {source:"htmllgo.png",name:"HTML"},
    {source:"csslogo.png",name:"CSS"},
    {source:"jslogo.png",name:"JAVASCRIPT"},
    {source:"reactlogo.png",name:"REACT"},
    {source:"reduxlogo.png",name:"REDUX"},
    {source:"chakralogo.jpeg",name:"CHAKRA UI"},
    {source:"nodelogo.png",name:"NODE"},
    {source:"expresslogo.png",name:"EXRESS"},
    {source:"mongodblogo.png",name:"MONGODB"},
    {source:"npmlogo.png",name:"NPM"},
    {source:"gitlogo.png",name:"GIT"},
    {source:"postmanlogo.png",name:"POSTMAN"},
    {source:"mongooselogo.png",name:"MONGOOSE"},
]
const Skills = () => {
   
  return (
    
 <Box id="tools" pos={"relative"} zIndex={2} border="1px solid white" p={"70px 0px"} >

<Box display={"inline-block"}>
        <Heading color="black">Teck Stack</Heading>
        <Box
          h="6px"
          w="100%"
          mt="10px"
          bg="rgb(34,83,200)"
    
          borderRadius={"5px"}
        ></Box>
      </Box>

      <Flex flexWrap={"wrap"} gap="60px"  justifyContent={"center"} w="90%"  m="auto" mt={"50px"} >
    {
        skillsArray.map((elem, index)=>(
            <SkillsCard key={index} {...elem}/>
        ))
    }
    </Flex>
    </Box>
  )
}

export default Skills